import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import { getSectionClasses as getBase } from '../api';
import { ClassesBookClassResponse as Base } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
  sectionId: string | number;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  Base
>();

export function useClassesBookClassLoader() {
  const context = useFetch();
  return {
    data: context.data,
    query: context.query,
    loading: context.loading,
    updateQuery: context.updateQuery,
    refresh: context.refresh,
  };
}

export const ClassesBookClassLoaderConsumer = FetchConsumer;

export function ClassesBookClassLoader({
  children,
  sectionId,
}: BaseLoaderProps) {
  const request = useCallback(() => {
    return getBase(sectionId);
  }, [sectionId]);

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately
      children={children}
    />
  );
}
